module.exports = __webpack_public_path__ + "img/20200619_160518.24297113.jpg";